export default __webpack_public_path__ + "static/media/features-home.57878e25.svg";